import React from 'react';
import { Modal } from 'antd';
import { Link } from 'react-router-dom';
import Spinner from '../../../components/Spinner';
import BarChart from '../../../components/SmartWidget/ChartComponents/BarChart';
import CustomActiveShapePieChart from '../../../components/SmartWidget/ChartComponents/CustomActiveShapePieChart';
import LineChart from '../../../components/SmartWidget/ChartComponents/LineChart';
import StackedAreaChart from '../../../components/SmartWidget/ChartComponents/StackedAreaChart';
import SimpleScatterChart from '../../../components/SmartWidget/ChartComponents/SimpleScatterChart';
import PieChartWithCustomizedLabel from '../../../components/SmartWidget/ChartComponents/PieChartWithCustomizedLabel';
import IconChart from '../../../components/SmartWidget/ChartComponents/IconChart';
import BestDriverChart from '../../../components/SmartWidget/ChartComponents/BestDriverChart';
import PieChart from '../../../components/SmartWidget/ChartComponents/PieChart';
import MultipleIconsChart from '../../../components/SmartWidget/ChartComponents/MultipleIconsChart';
import VorChart from '../../../components/SmartWidget/ChartComponents/VorChart';
import IconWithValues from '../../../components/SmartWidget/ChartComponents/IconWithValues';
import { SmartWidgetDropdownOptions } from '../../../types/types';

import './smartWidgetItem.scss';

export default function () {
    const {
        smartWidget, data, division, driver, asset, chartKey,
    } = this.props;
    const { visible, meters } = this.state;

    const currentTimeframe = this.state.timeframe;
    const assetDivisionOptions = [...division.divisionOptionsStrict];
    const userDivisionOptions = [...division.userDivisions];
    const assetOptions = [...asset.options];
    const driverOptions = [...driver.driverListStrict];
    let loading = false;
    if (data.id && smartWidget.loadingWidgets && smartWidget.loadingWidgets.includes(data.id)) {
        loading = true;
    }
    let chartHeight = 1;
    if (data.h > 1) {
        chartHeight = 2;
    }
    const meterList = meters.map((v) => (
        <p>
            <Link to={v.url} onClick={() => this.selectMeter(v)}>
                {v.title}
            </Link>
        </p>
    ));
    const dropdownOptions = [ 
        SmartWidgetDropdownOptions.Inspect, 
        SmartWidgetDropdownOptions.Edit, 
        SmartWidgetDropdownOptions.Delete, 
    ];

    const renderChart = (id) => {
        switch(id) {
            case 1:
                return (
                    <BarChart
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToDot(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 2:
                return (
                    <LineChart
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToDot(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 4:
                return (
                    <PieChart
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToInputType(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 5:
                return (
                    <MultipleIconsChart
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToInputType(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 6:
                return (
                    <StackedAreaChart
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToDot(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 7:
                return (
                    <IconWithValues
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToInputType(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 8:
                return (
                    <PieChartWithCustomizedLabel
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToInputType(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 10:
                return (
                    <IconChart
                        chartKey={chartKey}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 11:
                return (
                    <VorChart
                        chartKey={chartKey}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeVORTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={['edit widget', 'delete', 'see data in table']}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 12:
                return (
                    <SimpleScatterChart
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToDot(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 13:
                return (
                    <CustomActiveShapePieChart
                        chartKey={chartKey}
                        dotOnClick={(timeframe, index) => { this.goToInputType(timeframe, index, data.start); }}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveDatatypeValues(optionsData, data.chart_type_id); }}
                        divisions={assetDivisionOptions}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            case 14:
                return (
                    <BestDriverChart
                        chartKey={chartKey}
                        heightRatio={chartHeight}
                        timeframe={currentTimeframe}
                        onTimeframeChange={(timeframe) => this.changeTimeframe(timeframe)}
                        rightMenuOnClick={(rightMenu) => this.actionRightMenu(rightMenu)}
                        rightMenuItems={dropdownOptions}
                        tooltipText={data.title}
                        data={data.chartData}
                        defaultFirstOptionValue={data.datatype_a}
                        defaultSecondOptionValue={data.datatype_b}
                        defaultThirdOptionValue={data.datatype_c}
                        defaultFourOptionValue={data.datatype_d}
                        onAllOptionChange={(optionsData) => { this.saveBestDriverDatatypeValues(optionsData); }}
                        userDivisions={userDivisionOptions}
                        drivers={driverOptions}
                        assets={assetOptions} 
                    />
                );
            default:
                throw new Error('Invalid chart type');
        }
    }

    return (
        <Spinner 
            loading={loading}
            minHeight={200}
            size={20}
        >
            <Modal
                width="90%"
                title="Select Meter"
                footer={null}
                open={visible}
                style={{ top: 20 }}
                onOk={() => this.setState({ visible: false })}
                onCancel={() => this.setState({ visible: false })}
                getContainer={`#modalContent_${chartKey}`}
            >
                <p>Please select which meter you would like to see.</p>
                {meterList}
            </Modal>
            {renderChart(data?.chart_type_id || null)}
        </Spinner>
    );
}
